export { MAP_CLICK } from '@tmapy/mapcore';

export const SET_INFO_STATE = '@info/SET_INFO_STATE';
export const SET_INFO_SERVICE_DATA = '@info/SET_INFO_SERVICE_DATA';
